define(
  [
    'backbone',
    'marionette',
    'underscore',
    'jquery',
    './model',
    '../avatar-list/index',
    '../simple-user/index',
    '../../libs/views/Tooltip',
    '../../libs/translationsUtils/translations',
    '../../utils/globalEvents',
    './template.html'
  ],
  function (
    Backbone,
    Marionette,
    _,
    $,
    PostLikesModel,
    AvatarsListView,
    SimpleUserView,
    Tooltip,
    translations,
    events,
    template
  ) {
    var batchTimer
    var batchIds = []
    var batchPromises = []

    function addRequestToBatch (postId) {
      var d = $.Deferred()
      batchPromises.push(d)
      batchIds.push(postId)
      clearTimeout(batchTimer)
      batchTimer = setTimeout(function () {
        var promisesToResolve = batchPromises.concat([])
        $.ajax({
          url: '/widget/getPostLikes',
          data: {
            post_ids: batchIds
          },
          success: function (data) {
            _.each(promisesToResolve, function (d) {
              d.resolve(data)
            })
          },
          error: function () {
            d.fail()
          }
        })
        batchPromises = []
        batchIds = []
      }, 100)
      return d.promise()
    }

    return Marionette.LayoutView.extend({
      template: template,

      options: {
        maxNumberOfAvatars: 3,
        height: 21,
        margin: 14,
        isVoteModal: false
      },

      ui: {
        tooltip: '.js-likes-tooltip',
        avatars: '.post-like-list__avatars',
        allUsers: '.post-like-list__complete-list'
      },

      fetchData: function () {
        var self = this
        addRequestToBatch(this.options.postId).then(function (data) {
          self.parseRequestData((data || {})[self.options.postId])
        })
      },

      parseRequestData: function (data) {
        var currentUserHasLiked = false
        this.model.set('gotData', true)
        if (!data) {
          this.model.set({
            allUsers: new Backbone.Collection([]),
            currentUserHasLiked: currentUserHasLiked
          })
          return
        }
        var users = new Backbone.Collection(data)
        var currentUserInLikeList = users.remove(this.options.currentUser.id)
        if (currentUserInLikeList) {
          currentUserHasLiked = true
          users.unshift(currentUserInLikeList)
        }

        this.model.set({
          allUsers: users,
          currentUserHasLiked: currentUserHasLiked
        })
        this.render()
      },

      onRender: function () {
        if (this.model.numberOfLikes()) {
          new Tooltip({ el: this.ui.tooltip }).render()
          this.$el.removeClass('is-inactive')
        } else {
          this.$el.addClass('is-inactive')
        }

        new AvatarsListView({
          collection: this.model.previewUsers(),
          size: 'XS',
          showRank: false,
          el: this.ui.avatars
        }).render()

        new Marionette.CollectionView({
          collection: this.model.get('allUsers'),
          childView: SimpleUserView,
          getChildViewOptions: { avatarSize: 's' },
          el: this.ui.allUsers
        }).render()

        if (!this.model.get('gotData')) return

        this.$el.css(
          this.model.numberOfLikes()
            ? {
              height: this.options.height,
              'margin-bottom': this.options.margin,
              overflow: 'visible'
            }
            : {
              height: 0,
              'margin-bottom': 0,
              overflow: 'hidden'
            }
        )
        this.$el.children().fadeIn(300)
      },

      onPostLike: function (data) {
        var allUsers = this.model.get('allUsers')
        if (data.currentUserHasLiked) {
          allUsers.unshift(this.options.currentUser)
        } else {
          allUsers.remove(this.options.currentUser.id)
        }
        this.model.set({
          currentUserHasLiked: data.currentUserHasLiked
        })
        var self = this
        return this.$el.children().fadeOut(100).promise().done(function () {
          self.render()
        })
      },

      initialize: function () {
        this.options.postId = parseInt(this.options.postId, 10)
        if (!this.options.postId) throw new Error('Missing postId')
        if (!this.options.currentUser) throw new Error('Missing currentUser')

        translations.addTranslationDict(this.options.translations)

        this.model = new PostLikesModel({
          allUsers: new Backbone.Collection([]),
          maxNumberOfAvatars: this.options.maxNumberOfAvatars,
          currentUserHasLiked: this.options.currentUserHasLiked,
          isVoteModal: this.options.isVoteModal
        })

        events.commands.setHandler(
          'post:like:' + this.options.postId,
          this.onPostLike.bind(this)
        )

        this.fetchData()
      }
    })
  }
)
